import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"
import { getRequestUrl } from "@tanstack/react-start/server"

import { getSessionUser } from "../session.server"

const LOGIN_ROUTE = "/login"

function loginRedirect(redirectTo?: string): never {
  const requestURLObject = getRequestUrl()
  const target = redirectTo ?? `${requestURLObject.pathname}${requestURLObject.search}`
  throw redirect(
    target && target !== "/"
      ? { to: LOGIN_ROUTE, search: { redirectTo: target } }
      : { to: LOGIN_ROUTE },
  )
}

/** Returns the signed-in user, or redirects to /login. */
export const requireSession = createServerFn({ method: "GET" })
  .validator((data?: { redirectTo?: string }) => data)
  .handler(async ({ data }) => {
    const user = await getSessionUser()
    if (user) return user
    loginRedirect(data?.redirectTo)
  })

/** Returns the signed-in user's id, or redirects to /login. */
export const requireUserId = createServerFn({ method: "GET" }).handler(async () => {
  const user = await getSessionUser()
  if (user) return user.id
  loginRedirect()
})

/** Returns the signed-in user, or `null` — never redirects. */
export const getCurrentUser = createServerFn({ method: "GET" }).handler(async () => {
  return { user: await getSessionUser() }
})

export const requireGuest = createServerFn({ method: "GET" }).handler(async () => {
  if (await getSessionUser()) {
    throw redirect({ to: "/" })
  }
})
